export enum EstateType {
  fee_simple = 'fee_simple',
  leasehold = 'leasehold',
  life_estate = 'life_estate',
  remainder_of_a_life_estate = 'remainder_of_a_life_estate',
}
